export const SET_CURRENT_DASH = 'EPIC/DASH_SET_CURRENT';
